import React from 'react';
import About1 from './1';
import About2 from './2';
import About3 from './3';
import About4 from './4';
function About() {
  return (
    <>
      <About1 />
      <About2 />
      <About3 />
      <About4 />
    </>
  );
}

export default About;
